export default __webpack_public_path__ + "static/media/work-workspace-logo.1e58b390.svg";